module.exports = __webpack_public_path__ + "img/bitmap.04fe4b60.png";